import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '@pryspace/shared/environments';
import {
  TenantMemberPatch,
  TenantMemberAttach,
  TenantMember,
  TenantUserLookup,
  Paginated,
  unwrapList,
} from './models';

@Injectable({ providedIn: 'root' })
export class MembersService {
  private http = inject(HttpClient);
  private api = inject(ApiUrlService);

  private base(slug: string): string {
    return `v1/tenants/${slug}`;
  }

  async list(slug: string): Promise<TenantMember[]> {
    const res = await firstValueFrom(
      this.http.get<Paginated<TenantMember>>(this.api.url(`${this.base(slug)}/members/`)),
    );
    return unwrapList(res);
  }

  async searchUsers(slug: string, query: string): Promise<TenantUserLookup[]> {
    const res = await firstValueFrom(
      this.http.get<TenantUserLookup[] | Paginated<TenantUserLookup>>(
        this.api.url(`${this.base(slug)}/users/?q=${encodeURIComponent(query)}`),
      ),
    );
    return unwrapList(res);
  }

  add(slug: string, payload: TenantMemberAttach) {
    return firstValueFrom(
      this.http.post<TenantMember>(this.api.url(`${this.base(slug)}/members/`), payload),
    );
  }

  detail(slug: string, id: string) {
    return firstValueFrom(
      this.http.get<TenantMember>(this.api.url(`${this.base(slug)}/members/${id}/`)),
    );
  }

  update(slug: string, id: string, patch: TenantMemberPatch) {
    return firstValueFrom(
      this.http.patch<TenantMember>(this.api.url(`${this.base(slug)}/members/${id}/`), patch),
    );
  }

  delete(slug: string, id: string) {
    return firstValueFrom(this.http.delete(this.api.url(`${this.base(slug)}/members/${id}/`)));
  }
}
